// src/pages/ProjectsPage.js
import React from 'react';
import ProjectCard from '../components/ProjectCard';
import projectsData from '../data/projects.json';
import '../styles/ProjectsPage.css';

function ProjectsPage() {
  return (
    <div className="projects-page">
      <h1>Ongoing Projects</h1>
      <div className="projects-grid">
        {projectsData.map((project) => (
          <ProjectCard
            key={project.id}
            isNextGen={project.isNextGen}
            projectName={project.projectName}
            projectLogo={project.projectLogo}
            fundingOrganizations={project.fundingOrganizations}
            researchAreas={project.researchAreas}
            startDate={project.startDate}
            endDate={project.endDate}
            body={project.body}  // Passing the body to ProjectCard
          />
        ))}
      </div>
    </div>
  );
}

export default ProjectsPage;
